import PlayerData from "./PlayerData";
import { SaveData } from "./SaveData";

export default class WebPlayerData extends PlayerData {
	private get localStorageKey(): string {
		return this._gameId + "_SaveData";
	}

	private _gameId: string;
	private _saveData: SaveData;
	public get saveData(): SaveData {
		return this._saveData;
	}

	private _onLoaded: () => void;
	public get onLoaded(): () => void {
		return this._onLoaded;
	}
	public set onLoaded(f: () => void) {
		this._onLoaded = f;
	}

	constructor(gameId: string) {
		super();
		this._gameId = gameId;
		PlayerData.Instance = this;
		this._isLoaded = false;
	}

	load(): void {
		const base64String = localStorage.getItem(this.localStorageKey);
		if (base64String != "" && base64String != null) {
			const jsonText = window.atob(base64String);
			let saveData = <SaveData>JSON.parse(jsonText);
			if (!saveData.medalsEarned) {
				console.log("Save data is out of date");
				saveData = new SaveData();
			}
			this._saveData = saveData;
			console.log(this._saveData);
		} else {
			this._saveData = new SaveData();
		}

		setTimeout(() => {
			if (this._onLoaded) this._onLoaded();
			this._isLoaded = true;
		}, 1);
	}

	save(): void {
		const jsonString = JSON.stringify(this._saveData);
		const base64String = window.btoa(jsonString);
		localStorage.setItem(this.localStorageKey, base64String);
	}

	reset(): void {
		localStorage.removeItem(this.localStorageKey);
		this._saveData = new SaveData();
	}
}
